import api from ".";

export default async function getCondominia(residentialId: number) {
  const response = await api.get(`/residential/getCondominia/${residentialId}`);

  return response.data;
}
